export default function(ngModule) {
    ngModule.factory('Shop', function(BaseClass,$q, $http, sortByPredecessor, $injector, Tracker) {

        /**
         * Constructor function
         *
         * @constructor
         * @param {Object} attributes Initial attributes for the model
         */
        function Shop(attributes) {
            _.assign(this,attributes);
        }
        Shop.modelName = 'Shop';

        /**
         * Override the delete method so a user can't delete system shops (import, guestlist, etc)
         *
         * @return {Promise} Resolves when deleted
         */
        Shop.prototype.$delete = function() {
            let url = `/shop/${ this.guid }`;
            return this.isSystemShop().then(status => {
                if(status) {
                    this.broadcastAPIMessage({
                        status: 900,
                        config: { url: url, method: 'DELETE' }
                    });
                    return $q.reject(new Error('Cant delete a system shop'));
                }
                Shop.cached.remove(this.guid);
                return $http.delete(url).then(response => {
                    this.broadcastAPIMessage(response);
                    return response;
                }, error => {
                    if(_.get(error, 'data.error_description') === 'Not allowed. Already Tickets purchased')
                        error.status = 901;
                    this.broadcastAPIMessage(error);
                    return $q.reject(error);
                });
            });
        };

        BaseClass.apply(Shop);

        Shop.validates({
            name: {
                required: true
            },
            event_selection: {
                required: true,
                inclusion: {
                    in: ['auto','enabled','disabled']
                }
            },
            company_terms: {
                format: {
                    regex: {
                        regex: /^https?:\/\//,
                        message: 'Must be a valid url'
                    }
                }
            },
            google_tag: {
                format: {
                    regex: {
                        regex: /^GTM-[A-Za-z0-9]{6,}/,
                        message: 'Not a valid tag'
                    }
                }
            },
            facebook_page_url: {
                format: {
                    regex: {
                        regex: /^https:\/\/www.facebook.com\/.+/,
                        message: 'Not a valid facebook page, must start with https://www.facebook.com'
                    }
                }
            }
        });

        Shop.configureApi('/shop/:guid', { queryAdmin: '/shop/:status/:company', reinstate: '/shop/:guid/reinstate' });
        Object.defineProperty(Shop.prototype, 'toString', {
            value: function() {
                return this.name;
            },
            enumerable: false,
            configurable: false
        });

        Shop.configureAPIMessages({
            'POST /shop/:shop_guid/products': {
                406: 'models.shop.notice.productAlreadyAssigned'
            },
            'DELETE /shop/:shop_guid/products': {
                406: 'models.shop.notice.productNotAssigned'
            },
            'DELETE /shop/:shop_guid': {
                900: 'models.shop.notice.deleteSystemShopDenied',
                901: 'models.shop.notice.hasSoldTickets'
            },
            'POST /shop/:shop_guid/tickets': {
                406: 'models.shop.notice.ticketAlreadyAssigned'
            },
            'DELETE /shop/:shop_guid/tickets': {
                406: 'models.shop.notice.ticketNotAssigned'
            }
        });

        Shop.belongsToMany('PaymentMethod', 'payment_methods', '/shop/:guid/payment_methods/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            {
                type: 'query',
                // fn: function(modelName, url, instance, child, pivot) {
                //     // Only query the cache since there currently is no API endpoint yet and
                //     // the data is sent nested in shop#payment_methods
                //     return $q.resolve(instance.belongsToMany.restore(modelName));
                // },
                success: children => sortByPredecessor(children)
            },
            { type: 'reorder', url: '/shop/:guid/payment_methods/reorder' }
        ]);

        Shop.belongsToMany('Ticket', 'tickets', '/shop/:guid/tickets/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            {
                type: 'query',
                success: children => sortByPredecessor(children)
            },
            { type: 'reorder', url: '/shop/:guid/tickets/reorder' }
        ]);

        Shop.belongsToMany('Product', 'products', '/shop/:guid/products/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            {
                type: 'query',
                success: children => sortByPredecessor(children)
            },
            { type: 'reorder', url: '/shop/:guid/products/reorder' }
        ]);

        Shop.belongsToMany('MetaData', 'metaData', '/shop/:guid/metadata/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            {
                type: 'query',
                success: children => sortByPredecessor(children)
            },
            { type: 'reorder', url: '/shop/:guid/metadata/reorder' }
        ]);

        Shop.hasMany('Tracker', 'trackers', 'shop_id', '/shop/:guid/trackers');

        Shop.belongsToMany('Collapse', 'collapses', '/shop/:guid/collapse/^guid', [
            { type: 'attach' },
            { type: 'detach' },
            {
                type: 'query',
                success: children => sortByPredecessor(children)
            },
            { type: 'reorder', url: '/shop/:guid/collapse/reorder' }
        ]);

        Shop.prototype.$getLink = function(version) {
            switch(version) {
                case 'plain':
                case 'vanilla':
                    return SHOP_ROOT + this.guid;
                default:
                    return FANCY_SHOP_ROOT + this.guid;
            }
        };

        Shop.prototype.$getOrCreatePrimaryTracker = function() {
            var RelationAPI = $injector.get('RelationAPI');
            return RelationAPI.get('ShopLink', this.guid)
                .then(relations => {
                    if(relations.length) {
                        return Tracker.query()
                            .then(trackers => _.find(trackers, { guid: relations[0].right }))
                            .then(tracker => tracker ? tracker : $q.reject('Not Found'));
                    }
                    return Tracker.new({
                        name: `Link: ${this.name}`,
                        type: 'other',
                        shop_id: this.guid
                    }).$save().then(tracker => {
                        return RelationAPI.create('ShopLink', this.guid, tracker.guid)
                            .then(() => tracker);
                    });
                }).then(tracker => {
                    Object.defineProperty(this, 'link', {
                        value: TRACKER_ROOT + tracker.code,
                        writable: true
                    });
                    return tracker;
                }, error => {
                    Object.defineProperty(this, 'link', {
                        value: this.$getLink(),
                        writable: true
                    });
                    return $q.reject(error);
                });
        };

        /**
         * Checks if the current shop is a system shop
         *
         * @return {Promise<Boolean>} Resolves with true or false
         */
        Shop.prototype.isSystemShop = function() {
            var RelationAPI = $injector.get('RelationAPI');
            let promises = [
                RelationAPI.get('CompanyShop', this.guid, 'inverse'),
                RelationAPI.get('ImportShop', this.guid, 'inverse'),
                RelationAPI.get('OfflineShop', this.guid, 'inverse')
            ];
            return $q.all(promises)
                .then(responses => {
                    let relations = _.flatten(responses);
                    return !_.isEmpty(relations);
                });
        };

        Shop.queryUserShops = function() {
            var RelationAPI = $injector.get('RelationAPI');
            var Company = $injector.get('Company');
            var shops, company;

            return $q.all([
                Shop.query(),
                Company.getMe()
            ]).then(results => {
                shops = results[0];
                company = results[1];
                return $q.all([
                    RelationAPI.get('ImportShop', company.guid),
                    RelationAPI.get('OfflineShop', company.guid)
                ]).then(relations => {
                    relations = _.flatten(relations);
                    return _.filter(shops, shop => {
                        return !_.find(relations, { right: shop.guid });
                    });
                });
            });
        };

        return Shop;
    });
}
